import React from 'react';
import Events from '../../../Components/event';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import { ArrowLong } from '../../../../assets/img/svg/icons';

import { EventInterface } from '../../../Services/types';
interface ListInterface {
    past_events: EventInterface[]
}

const EventsSection: React.FC<ListInterface> = ({past_events}: ListInterface) => {

    return (
        past_events.length > 0 &&
        <section>
            <div className="bg-gradient-to-b from-light-blue to-white py-6 md:py-10">
                <div className="max-w-screen-xl mx-auto px-4">
                    <h2 className="font-semibold text-2xl md:mb-2 text-center">Eventos Realizados</h2>

                    <div className="max-w-screen-lg mx-auto">
                        <Swiper
                            loop
                            className='relative'
                            modules={[Navigation]}
                            navigation={{
                                prevEl: '.swiper-prev',
                                nextEl: '.swiper-next',
                            }}
                            breakpoints={{
                                767: { slidesPerView: 2 },
                                991: { slidesPerView: 3 },
                            }}
                        >

                            {[...past_events].reverse().map((event) => (
                                <SwiperSlide key={event.id} className='flex justify-center'>
                                    <div className="py-8 px-12 relative max-w-[340px]">
                                        <Events slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />
                                    </div>
                                </SwiperSlide>
                            ))}

                            <div className="swiper-prev z-40 absolute top-44 left-0 cursor-pointer group">
                                <ArrowLong className='-scale-x-100 fill-main-pink transition-all duration-200 group-hover:fill-main-blue' />
                            </div>

                            <div className="swiper-next z-40 absolute top-44 right-0 cursor-pointer group">
                                <ArrowLong className='transition-all fill-main-pink duration-200 group-hover:fill-main-blue' />
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventsSection;